import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { SnackbarProvider } from 'notistack';
//
import App from './App';
// import './locales/i18n';
import 'intro.js/introjs.css';
import './style-overrides.css';

// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <Suspense>
        <SnackbarProvider
          maxSnack={3}
          iconVariant={{
            error: '⚠️ ',
            warning: '⚠️ ',

            success: '✓ ',
          }}
        >
          <App />
        </SnackbarProvider>
      </Suspense>
    </BrowserRouter>
  </HelmetProvider>
);
